/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import '../../client/asset/asset-comments.scss';

/* eslint-disable import/no-unresolved, import/default */

import assetCommentsTemplate from '../../client/asset/asset-comments.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.deviceNotes', [])
    .directive('cellularDeviceNotes', CellularDeviceNotes)
    .filter('linebreaks', lineBreak)
    .name;

/*@ngInject*/
function CellularDeviceNotes() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: "=",
            device: "="
        },
        controller: CellularDeviceNotesController,
        controllerAs: 'vm',
        templateUrl: assetCommentsTemplate
    };

}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function CellularDeviceNotesController($scope, $timeout, $translate, $mdDialog, types, agTypes, agUtils, userService, attributeService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.allowCommentsEditing = true;

    var user = userService.getCurrentUser();
    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowCommentsEditing = false;
        }
    }

    vm.sendComment = sendComment;
    vm.editComment = editComment;
    vm.deleteComment = deleteComment;
    vm.enterCommentEditMode = enterCommentEditMode;
    vm.cancelCommentEditMode = cancelCommentEditMode;

    $scope.$watch(function () {
        return vm.device ? vm.device.label : null;
    }, function (title) {
        if (vm.ctx && title) {
            vm.ctx.widgetTitle = title + ' (' + agUtils.getFarmerDeviceName(vm.device.type) + '): Notes';
            vm.assetComments = [];
            loadComments();
        }
    });

    function loadComments() {
        vm.loading = true;
        vm.commentEditMode = false;
        vm.newComment = "";

        attributeService.getEntityAttributesValues(vm.device.id.entityType, vm.device.id.id, types.attributesScope.server.value, ["comments"]).then(
            function success(data) {
                vm.assetComments = data.length ? angular.fromJson(data[0].value) : [];
                vm.loading = false;
            },
            function fail() {
                vm.loading = false;
            }
        );
    }

    function sendComment() {
        if (vm.newComment) {
            vm.sending = true;
            var comment = {};
            comment.timestamp = new Date().getTime();
            comment.commentValue = vm.newComment;
            comment.userName = (user.firstName || user.lastName) ? user.firstName + " " + user.lastName : $translate.instant('ag.asset.anonymous');
            vm.assetComments.unshift(comment);
            var editedComments = angular.toJson(vm.assetComments);
            vm.newComment = "";

            attributeService.saveEntityAttributes(vm.device.id.entityType, vm.device.id.id, types.attributesScope.server.value, [{
                key: "comments",
                value: editedComments
            }]).then(
                function success() {
                    vm.sending = false;
                },
                function fail() {
                    vm.sending = false;
                }
            );
        }
    }

    function editComment() {
        if (vm.editedCommentValue) {
            vm.editedComment.commentValue = vm.editedCommentValue;
            if (vm.originalCommentvalue != vm.editedComment.commentValue) {
                vm.editedComment.edited = true;
            } else {
                vm.commentEditMode = false;
                return;
            }
            vm.commentEditMode = false;
            vm.sending = true;

            var editedComments = angular.toJson(vm.assetComments);
            attributeService.saveEntityAttributes(vm.device.id.entityType, vm.device.id.id, types.attributesScope.server.value, [{
                key: "comments",
                value: editedComments
            }]).then(
                function success() {
                    vm.sending = false;
                },
                function fail() {
                    vm.sending = false;
                }
            );
        }
    }

    function deleteComment($event, comment) {
        if ($event) {
            $event.stopPropagation();
        }
        vm.commentEditMode = false;

        var title = $translate.instant('ag.asset.delete-comment-title');
        var content = $translate.instant('ag.asset.delete-comment-text');

        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title(title)
            .htmlContent(content)
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
            vm.sending = true;
            var index = vm.assetComments.indexOf(comment);
            vm.assetComments.splice(index, 1);

            var editedComments = angular.toJson(vm.assetComments);
            attributeService.saveEntityAttributes(vm.device.id.entityType, vm.device.id.id, types.attributesScope.server.value, [{
                key: "comments",
                value: editedComments
            }]).then(
                function success() {
                    vm.sending = false;
                },
                function fail() {
                    vm.sending = false;
                }
            );
        });
    }

    function enterCommentEditMode(comment) {
        vm.editedComment = comment;
        vm.commentEditMode = true;
        vm.originalCommentvalue = comment.commentValue;
        vm.editedCommentValue = comment.commentValue;
        $timeout(function () {
            var editPanel = angular.element("#asset-comment-edit");
            editPanel.focus();
        });
    }

    function cancelCommentEditMode() {
        vm.commentEditMode = false;
    }
}

/*@ngInject*/
function lineBreak() {
    return function (text) {
        return text.replace(/\n/g, "<br>");
    }
}
